import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ProductCarouselTypeState from "@tCooneyBrothers/Store/Data/ProductCarouselType/ProductCarouselTypeState";

import { Draft } from "immer";

const initialState: ProductCarouselTypeState = {
    accessory: false,
    similarItems: false,
    relatedItems: false,
    spareParts: false,
};

const reducer = {
    "Custom/ProductCarousel/SetAccessories": (draft: Draft<ProductCarouselTypeState>, action: { result: any }) => {
        draft.accessory = action.result;
    },
    "Custom/ProductCarousel/SetSimilarItems": (draft: Draft<ProductCarouselTypeState>, action: { result: any }) => {
        draft.similarItems = action.result;
    },
    "Custom/ProductCarousel/SetRelatedItems": (draft: Draft<ProductCarouselTypeState>, action: { result: any }) => {
        draft.relatedItems = action.result;
    },
    "Custom/ProductCarousel/SetSpareParts": (draft: Draft<ProductCarouselTypeState>, action: { result: any }) => {
        draft.spareParts = action.result;
    },
    "Custom/ProductCarousel/Reset": (draft: Draft<ProductCarouselTypeState>, action: { result: any }) => {
        draft.accessory = false;
        draft.relatedItems = false;
        draft.similarItems = false;
        draft.spareParts = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
